import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { loadUser } = useAuthStore();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      // Extract token from URL fragment: /auth/callback#token=xxx
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const token = params.get('token');

      if (!token) {
        setError('No authentication token received');
        setTimeout(() => navigate('/login?error=no_token', { replace: true }), 2000);
        return;
      }

      // Store the token (same as email/password login flow)
      localStorage.setItem('token', token);

      // Load the full user profile from /api/auth/me
      try {
        await loadUser();
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('Failed to load user after SSO:', err);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setError('Failed to authenticate. Please try again.');
        setTimeout(() => navigate('/login?error=load_failed', { replace: true }), 2000);
      }
    };

    handleCallback();
  }, [navigate, loadUser]);

  if (error) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', flexDirection: 'column', gap: '16px',
        background: '#F4F6FB',
      }}>
        <p style={{ color: '#EF4444', fontSize: '16px', fontWeight: 500 }}>{error}</p>
        <p style={{ color: '#94A3B8', fontSize: '14px' }}>Redirecting to login...</p>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', flexDirection: 'column', gap: '16px',
      background: '#F4F6FB',
    }}>
      <div style={{
        width: 40, height: 40,
        border: '3px solid #E2E8F0',
        borderTopColor: '#0C6B62',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      <p style={{ color: '#64748B', fontSize: '16px' }}>Signing you in...</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default AuthCallback;
